import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatSelectionCard = createCustomElementWrapper('kat-selection-card', 'KatSelectionCard', {
    'imageAlt': 'image-alt',
    'imageSrc': 'image-src',
}, {
    'onChange': 'change',
}, [
    'subheader',
    'body',
    'footer',
    'image',
]);
